import React from 'react';
import propTypes from 'prop-types';
import { Stack, Chip } from '@metarouter-private/mr-mui';
import TextCell from 'app/components/data-table/TextCell';
import DisabledRevisionWarning from 'app/shared/components/integrations/DisabledRevisionWarning';
import formatRevisionText from './formatRevisionText';

function StagedRevisionCell({ stagedRevision, deployedRevision, stagedForDelete, revisionDisabled }) {
  if (stagedForDelete) {
    return <Chip color="error" size="small" variant="soft" label="Staged for delete" />;
  }

  // MATCHING REVISION NOTE
  // It is possible that stagedRevision === deployedRevision with a staged / un-deployed
  // change to a pipeline variable. This use-case is _not_ handled here and confirmed
  // with Matt B. (product). It should be a minority edge case for the integrations overview and users
  // would mainly be checking to see if revision numbers match or not.
  // The pipeline detail page will have an accurate status.
  if (Number.isInteger(stagedRevision) && Number.isInteger(deployedRevision) && stagedRevision === deployedRevision) {
    return <Chip color="secondary" size="small" variant="soft" label="No staged revisions" />;
  }

  const revisionText = formatRevisionText(stagedRevision);

  if (!revisionDisabled) {
    return <TextCell variant="body2" text={revisionText} />;
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <TextCell variant="body2" text={revisionText} />
      <DisabledRevisionWarning />
    </Stack>
  );
}

StagedRevisionCell.propTypes = {
  stagedRevision: propTypes.number,
  deployedRevision: propTypes.number,
  stagedForDelete: propTypes.bool,
  revisionDisabled: propTypes.bool,
};

export default StagedRevisionCell;
